module.exports = __webpack_public_path__ + "img/icon04.f80e28a0.png";